import { STORE } from "../lib/api";

const PAGES = {
    privacy: {
        title: "Privacy Policy",
        testId: "privacy-page",
        body: [
            "This website is an informational site for Freddie's Afro Caribbean Store. We do not operate customer accounts, online ordering, or payment facilities on this site.",
            "We do not collect personal information through this website beyond standard, anonymous website analytics. If you contact us by telephone, any information you share is used only to respond to your enquiry.",
            "This site links to Google Maps for directions; Google may process data according to its own privacy policy when you use those links.",
            `If you have any questions about privacy, you can reach us in store at ${STORE.addressShort} or by phone on ${STORE.phones[0].label}.`,
        ],
    },
    terms: {
        title: "Terms of Use",
        testId: "terms-page",
        body: [
            "This website provides general information about Freddie's Afro Caribbean Store, including our product ranges, opening hours and contact details.",
            "Product photographs and descriptions are for illustration; availability in store can vary, and prices are only confirmed in store.",
            "Opening hours and contact details are kept up to date where possible, but may change on public holidays or special occasions.",
            `Questions about this website? Visit us at ${STORE.addressShort} or call ${STORE.phones[0].label}.`,
        ],
    },
};

export default function Legal({ page }) {
    const content = PAGES[page];
    return (
        <main data-testid={content.testId} className="bg-slate-50 min-h-[60vh]">
            <section className="bg-[#0033A0] py-14">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="font-heading text-4xl font-extrabold text-white" data-testid={`${page}-heading`}>
                        {content.title}
                    </h1>
                </div>
            </section>
            <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="space-y-4 text-slate-600 leading-relaxed" data-testid={`${page}-body`}>
                    {content.body.map((para, i) => (
                        <p key={i}>{para}</p>
                    ))}
                </div>
            </section>
        </main>
    );
}
